
const cner_config = {
  prod: {
    cner_base_url: 'https://campaigner.voegeli.ch/',
    cner_service_url: 'https://campaigner20.voegeli.ch/service/',
    cner_landing_url: 'https://campaigner20.voegeli.ch/landing/',
    cner_hcaptcha_site_key: 'ab3e26c6-bfe4-4aa8-8cb7-1fe1e5071d83',
    cner_nav_logo_text: 'ampaigner',
    cner_bg_img_class: 'bg-cn-bg-img-login'
  }, test: {
    cner_base_url: 'https://cnertest.voegeli.ch/',
    cner_service_url: 'https://cnerbackendtest.voegeli.ch/service/',
    cner_landing_url: 'https://cnerbackendtest.voegeli.ch/landing/',
    cner_hcaptcha_site_key: '10000000-ffff-ffff-ffff-000000000001',
    cner_nav_logo_text: 'ampaigner-TEST-SYSTEM',
    cner_bg_img_class: 'bg-cn-bg-img-login-test'
  }, peto: {
    cner_base_url: 'http://localhost:3000/',
    cner_service_url: 'http://cner.backend.ubuntudev20.int/service/',
    cner_landing_url: 'http://cner.backend.ubuntudev20.int/landing/',
    cner_hcaptcha_site_key: '10000000-ffff-ffff-ffff-000000000001',
    cner_nav_logo_text: 'ampaigner-dev-PETO',
    cner_bg_img_class: 'bg-cn-bg-img-login-test'
  }, kemu: {
    cner_base_url: 'http://localhost:3000/',
    cner_service_url: 'http://cner20.vgmac244.voegeli.int/service/',
    cner_landing_url: 'http://cner20.vgmac244.voegeli.int/landing/',
    cner_hcaptcha_site_key: '10000000-ffff-ffff-ffff-000000000001',
    cner_nav_logo_text: 'ampaigner-dev-KEMU',
    cner_bg_img_class: 'bg-cn-bg-img-login-test'
  }, raza: {
    cner_base_url: 'http://localhost:3000/',
    cner_service_url: 'http://cner20.vgmac220.voegeli.int/service/',
    cner_landing_url: 'http://cner20.vgmac220.voegeli.int/landing/',
    cner_hcaptcha_site_key: '10000000-ffff-ffff-ffff-000000000001',
    cner_nav_logo_text: 'ampaigner-dev-RAZA',
    cner_bg_img_class: 'bg-cn-bg-img-login-test'
  }, juin: {
    cner_base_url: 'http://localhost:3000/',
    cner_service_url: 'http://cner20.vgmac227.voegeli.int/service/',
    cner_hcaptcha_site_key: '10000000-ffff-ffff-ffff-000000000001',
    cner_nav_logo_text: 'ampaigner-dev-JUIN',
    cner_bg_img_class: 'bg-cn-bg-img-login-test'
  }, towi: {
    cner_base_url: 'http://localhost:3000/',
    cner_service_url: 'http://cner20.vgmac245.voegeli.int/service/',
    cner_hcaptcha_site_key: '10000000-ffff-ffff-ffff-000000000001',
    cner_nav_logo_text: 'ampaigner-dev-TOWI',
    cner_bg_img_class: 'bg-cn-bg-img-login-test'
  }
}

export default cner_config;
